<template>
  <div>
    <label
      class="input__label"
      :for="id"
    >
      {{ translate(label) }} <span v-if="block.is_required">*</span>
    </label>

    <input-national-id
      class="margin__t--6"
      v-model="model"
      :v="validator"
      :id="id"
      :placeholder="translate(placeholder)"
    />

    <p
      class="additional-text"
      v-if="translate(text)"
    >
      {{ translate(text) }}
    </p>
  </div>
</template>

<script setup>
import { ref, computed, inject, watch } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { useUserStore } from '@/stores/UserStore'
import { useModule } from '@/composables/app/useModule'
import { useProcedureBlockValidator } from '@/composables/modules/procedures'
import { get as _get } from 'lodash'

import InputNationalId from '&/atoms/InputNationalId'

const { block } = defineProps({
  block: { type: Object, required: true }
})

const procedure_execution = inject('procedure_execution')

const external = ref(null)

const validations = computed(() => [...block.mandatory, external.value])

const { translate } = useI18n()
const { fetchValidateNationalId } = useUserStore()
const { label, placeholder, model, id, attributes } = useModule({ component: block, parent: procedure_execution })
const { validator } = useProcedureBlockValidator({ validations, state: model })

const text = computed(() => _get(attributes.value, 'text', {}))

watch(model, async () => {
  if (!model.value || validator.value?.minLength?.$invalid) return external.value = null

  try {
    await fetchValidateNationalId({ query: { national_id: model.value } })

    external.value = null
  } catch {
    external.value = 'external:errors.input_national_id_invalid'
  }
}, { immediate: true })
</script>

<style lang="scss" scoped>
.additional-text {
  color: $lg;
  margin-top: 4px;
  font-size: rem(12px);
  white-space: pre-line;
}
</style>